import { FormikErrors } from 'formik';

import { AboutYouValues } from './AboutYou.types';

export const AboutYouValidate = (fields: AboutYouValues) => {
  let errors: FormikErrors<AboutYouValues> = {};
  if (!fields.aboutMeName) {
    errors.aboutMeName = 'Mandatory';
  }
  if (!fields.aboutMeDescription) {
    errors.aboutMeDescription = 'Mandatory';
  }
  return errors;
};
